import {ElementGroupElement} from "../element/Element";
import {SimpleGadget} from "../gadget/Gadget";
/**
 * Created by Victor Rojo on 27/8/18.
 */
export class Widget{
  constructor(
    public widgetId: string,
    public iPlaceId: number,
    public widgetTypeId: number,
    public name: string,
    public statusLevelId: number,
    public statusUpdate: number,
    public positionX: number,
    public positionY: number,
    public visible: boolean,
    public minimized: boolean,
    public columns: number,
    public rows: number,
    public widgetStatusList:WidgetStatusLine[]
  ){}
}

export const WidgetTypes = {
  GADGET_MAP: 1,
  WEATHER: 2,
  CONSUMPTION_METER: 3,
  CLOCK: 4,
  LIGHTS_ON: 5,
  SECURITY: 6,
  NETWORK_DEVICES: 7,
  CONFORT: 8,
  SOCKETS_ON: 9,
  CAMERA: 10,
  SCHEDULED_TASKS: 11,
  CHART: 12,
  ADVICES: 13,
  ACTIVITY: 14,
  BOILER: 15,
  TEMPERATURE: 16,
  GADGET_GROUP: 17,
  CONFIG_CHART: 18,
  STATUS_GROUP: 19,
  DOMO_EXTENSIONS: 20,
  TANK: 21,
  PUMP: 22,
  PRICE_POLE: 23,
  INDICATOR: 24
};

export const StatusLevels = {
  OK: 1,
  WARNING: 2,
  ERROR: 3,
  FATAL: 4,
  MAINTENANCE: 5
};

export class WidgetStatusLine {
  constructor(
    public statusNotificationId: string,
    public name: string,
    public description: string,
    public launchDate: number,
    public insertedDate: number,
    public receivedDate: number,
    public statusLevelId: number,
    public cleanable: boolean
  ){}

}

export class WidgetStatus {
  constructor(
    public widgetId: string,
    public iPlaceId: string,
    public statusLevelId: number,
    public statusUpdate: number,
    public lines:WidgetStatusLine[]
  ){}

}

export class ElementGroupWidget extends Widget{
  elements:ElementGroupElement[];
}

export class GadgetGroupWidget extends Widget{
  gadgets:SimpleGadget[];
}

export class TankWidget extends Widget{
  tankId:string;
  tankName:string;
  temperature:number;
  capacity:number;
  productVolume:number;
  productHeight:number;
  waterVolume:number;
  waterHeight:number;
  updated:number;
  tankDeliveries:{
    tankDeliveryLogId:string,
    name:string,
    startDate:number,
    endDate:number,
    volume:number,
    tcCorrVol:number,
    startVolume:number,
    endVolume:number,
    startDensity:number,
    endDensity:number,
    startTCDensity:number,
    endTCDensity:number,
    startTemp:number,
    endTemp:number,
    delivProdTemp:number,
    saleAdjustedVolume:number,
    saleAdjustedTCVol:number,
    saleVolume:number,
    updated:number
  }[];
}

export class PumpWidget extends Widget{
  pumpId:string;
  status:string;
  mode:string;
  volumeToday:number;
  moneyToday:number;
  volumeTotal:number;
  moneyTotal:number;
  salesInfo:boolean;
  updated:number;
  fuellingOptions:{
    fuellingOptionId:string,
    name:string,
    status: boolean,
    volumeToday: number,
    volumeTotal: number
  }[];
}

export class PricePoleWidget extends Widget{
  pricePoleId:string;
  status:boolean;
  salesInfo:boolean;
  updated:number;
  priceOptions: {
    priceOptionId:string,
    name:string,
    price:number
  }[];
}

export class CameraWidget extends Widget{
  cameras: {
    cameraId:string,
    iPlaceId:string,
    name:string
  }[];
}

export class IndicatorWidget extends Widget{
  gadgets:SimpleGadget[];
}

export class ChartWidget extends Widget{
  chartType:number;
  chartUnit:number;
  chartTimeGroup:number;
  chartTitle:string;
  series:ChartSerie[];
}

export class ChartSerie extends Widget{
  elementId:string;
  name:string;
  data:number[][];
}
export const ChartTypes = {
  LINE: 1,
  BAR: 2,
  BINARY: 3,
  DONUT: 4
};
export const ChartTimeGroups = {
  HOUR: 1,
  DAY: 2,
  MONTH: 3,
  YEAR: 4
};
